import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Store } from '@ngrx/store';
import { PricingSchemeLinkService } from 'blg-akaun-ts-lib';
import { PricingSchemeModel } from '../../models/pricing-scheme.model';
import { PermissionStates } from '../../modules/permission/permission-controller/root';
import { SessionSelectors } from '../../modules/session/session-controller/selectors';
import { SessionStates } from '../../modules/session/session-controller/states';
import { AppConfig } from '../../visa';
import { ReplaySubject } from 'rxjs';
// import 'rxjs/add/operator/take';
import { SubSink } from 'subsink2';

interface PricingScheme {
  fiItemHdrGuid: string;
  priceName: string;
  priceAmount: number;
}


@Component({
  selector: 'app-pricing-scheme-access',
  templateUrl: './pricing-scheme.component.html',
  styleUrls: ['./pricing-scheme.component.css'],
  changeDetection: ChangeDetectionStrategy.Default,
})

export class PricingSchemeComponent implements OnInit, OnDestroy {

  @Input() fiItemHdrGuid: FormControl;
  @Input() unitPriceType: string;
  @Input() pricingSchemeAccessKey;
  @Output() selectedPricingScheme = new EventEmitter<any>();
  @Input() pricingScheme: FormControl= new FormControl();
  @Input() defaultPricingSchemeHdr: FormControl;
  defaultPriceScheme = new FormControl;

  pricingSchemefilterControl = new FormControl();
  filteredPricingScheme$: ReplaySubject<PricingScheme[]> = new ReplaySubject<PricingScheme[]>(1);

  private subs = new SubSink();
  dtoObject;
  authorization: string;
  appletGuid: string;
  tenantGuid: string;
  rank: string;
  apiVisa = AppConfig.apiVisa;
  pricingSchemeHdrGuids: any[] = [];
  filteredPricingSchemes : any[] = [];

  constructor(
      private pricingSchemeLinkService : PricingSchemeLinkService,
      protected readonly sessionStore: Store<SessionStates>,
      protected readonly pricingSchemeAccessStore: Store<PermissionStates>,
      
    ) {

  }

  ngOnInit() {
    this.subs.sink = this.sessionStore.select(SessionSelectors.selectRolePricingSchemeLink).subscribe(data => {
      data?.forEach(pricingSchemeLink => {
        this.pricingSchemeHdrGuids.push(pricingSchemeLink.bl_applet_role_pricing_scheme_link.pricing_scheme_guid);
      });

     })

    // console.log("Pricing Scheme Hdr Guids Array",this.pricingSchemeHdrGuids);
  }

  ngOnChanges() {
    //console.log("Access Key",this.pricingSchemeAccessKey);
    //console.log("Fi item hdr guid",this.fiItemHdrGuid);
    this.dtoObject = 
      {
        "item_hdr_guid" : this.fiItemHdrGuid.value,
        "item_line_guid" : "",
        "pricing_scheme_hdr_guids": this.pricingSchemeHdrGuids
    }
    this.authorization  = localStorage.getItem('authToken');
    this.appletGuid = sessionStorage.getItem('appletGuid');
     this.sessionStore.select(SessionSelectors.selectAppletLoginSubjectLink).subscribe(data => {
      //console.log("session selector data",data);
      this.tenantGuid = data.tenant_guid.toString();
    })

    this.sessionStore.select(SessionSelectors.selectUserRank).subscribe(data => {
     // console.log("User Rank",data);
      this.rank = data;
    })

    if( this.unitPriceType.toUpperCase() === "SALES"){
      this.getSalesSidePricingScheme();
    }
    else if( this.unitPriceType.toUpperCase() === "PURCHASE"){
      this.getPurchaseSidePricingScheme();
    }
  }

  getSalesSidePricingScheme(){
   // console.log("Sales Side Pricing Scheme Api");
    this.pricingSchemeLinkService.getSalesSidePricingSchemes(this.dtoObject,this.appletGuid,this.tenantGuid,this.rank,this.apiVisa).subscribe(data => {
     // console.log("Response for accessible pricing scheme",data);
     const  salesSidePricingSchemeList: any[] = [];
     data.data.forEach(data => {
        const pricingSchemeModel = new PricingSchemeModel();
        pricingSchemeModel.pricingSchemeAccessKey = data.item_hdr_guid.concat(data.item_line_guid ? data.item_line_guid : "");
        pricingSchemeModel.uom = data.uom;
        pricingSchemeModel.price_code = data.pricing_scheme_code;
        pricingSchemeModel.price_name = data.pricing_scheme_name;
        pricingSchemeModel.price_amount_incl_tax = data.sales_unit_price;
        pricingSchemeModel.price_amount_excl_tax = data.sales_unit_price_excl_tax;
        pricingSchemeModel.price_min = data.sales_min_price;
        pricingSchemeModel.price_max = data.sales_max_price;
        pricingSchemeModel.guid_pricing_scheme_hdr = data.guid_pricing_scheme_hdr;
        pricingSchemeModel.replacement_unit_price_excl_tax = data.replacement_unit_price_excl_tax;
        pricingSchemeModel.ref_price1_excl_tax = data.ref_price1_excl_tax;
        pricingSchemeModel.ref_price2_excl_tax = data.ref_price2_excl_tax;
        pricingSchemeModel.ref_price3_excl_tax = data.ref_price3_excl_tax;
        pricingSchemeModel.delta_price1_excl_tax = data.delta_price1_excl_tax;
        pricingSchemeModel.delta_price2_excl_tax = data.delta_price2_excl_tax;
        pricingSchemeModel.delta_price3_excl_tax = data.delta_price3_excl_tax;
        pricingSchemeModel.rebate_price1_excl_tax = data.rebate_price1_excl_tax;
        pricingSchemeModel.rebate_price2_excl_tax = data.rebate_price2_excl_tax;
        pricingSchemeModel.rebate_price3_excl_tax = data.rebate_price3_excl_tax;
        pricingSchemeModel.sales_min_price_excl_tax = data.sales_min_price_excl_tax;
        pricingSchemeModel.sales_max_price_excl_tax = data.sales_max_price_excl_tax;
        pricingSchemeModel.purchase_min_price_excl_tax = data.purchase_min_price_excl_tax;
        pricingSchemeModel.purchase_max_price_excl_tax = data.purchase_max_price_excl_tax;
        pricingSchemeModel.guid_pricing_scheme_link = data.guid

        //console.log("Pricing Scheme Model",pricingSchemeModel);
        salesSidePricingSchemeList.push(pricingSchemeModel);
     })

     //console.log("Pricing Scheme List",salesSidePricingSchemeList);

     this.filteredPricingSchemes = salesSidePricingSchemeList.filter(pricingScheme => 
      pricingScheme.pricingSchemeAccessKey === this.pricingSchemeAccessKey
    );

   // console.log("Filered Pricing Scheme",this.filteredPricingSchemes);
    //console.log("defaultPricingSchemeHdr", this.defaultPricingSchemeHdr.value)
    const defaultPricingSchemeModel = this.filteredPricingSchemes.find(l => l.guid_pricing_scheme_hdr === this.defaultPricingSchemeHdr?.value);

    if(defaultPricingSchemeModel){
     // console.log('defaultPricingSchemeModel',defaultPricingSchemeModel)
      this.onPriceSelected(defaultPricingSchemeModel);
      this.pricingScheme.patchValue(defaultPricingSchemeModel);
    } else if (this.filteredPricingSchemes.length == 1) {
      //console.log("filtered pricing scheme length",this.filteredPricingSchemes.length);
      this.onPriceSelected(this.filteredPricingSchemes[0])
    }
    })
    
  }

  getPurchaseSidePricingScheme(){
   // console.log("Purchase Side Pricing Scheme Api");
    this.pricingSchemeLinkService.getPurchaseSidePricingSchemes(this.dtoObject,this.appletGuid,this.tenantGuid,this.rank,this.apiVisa).subscribe(data => {
     // console.log("Response for accessible pricing scheme",data);
     const  purchaseSidePricingSchemeList: any[] = [];
     data.data.forEach(data => {
        const pricingSchemeModel = new PricingSchemeModel();
        pricingSchemeModel.pricingSchemeAccessKey = data.item_hdr_guid.concat(data.item_line_guid ? data.item_line_guid : "");
        pricingSchemeModel.uom = data.uom;
        pricingSchemeModel.price_code = data.pricing_scheme_code;
        pricingSchemeModel.price_name = data.pricing_scheme_name;
        pricingSchemeModel.price_amount_incl_tax = data.purchase_unit_price;
        pricingSchemeModel.price_amount_excl_tax = data.purchase_unit_price_excl_tax;
        pricingSchemeModel.price_min = data.purchase_min_price;
        pricingSchemeModel.price_max = data.purchase_max_price;
        pricingSchemeModel.guid_pricing_scheme_hdr = data.guid_pricing_scheme_hdr;
        pricingSchemeModel.replacement_unit_price_excl_tax = data.replacement_unit_price_excl_tax;
        pricingSchemeModel.ref_price1_excl_tax = data.ref_price1_excl_tax;
        pricingSchemeModel.ref_price2_excl_tax = data.ref_price2_excl_tax;
        pricingSchemeModel.ref_price3_excl_tax = data.ref_price3_excl_tax;
        pricingSchemeModel.delta_price1_excl_tax = data.delta_price1_excl_tax;
        pricingSchemeModel.delta_price2_excl_tax = data.delta_price2_excl_tax;
        pricingSchemeModel.delta_price3_excl_tax = data.delta_price3_excl_tax;
        pricingSchemeModel.rebate_price1_excl_tax = data.rebate_price1_excl_tax;
        pricingSchemeModel.rebate_price2_excl_tax = data.rebate_price2_excl_tax;
        pricingSchemeModel.rebate_price3_excl_tax = data.rebate_price3_excl_tax;
        pricingSchemeModel.sales_min_price_excl_tax = data.sales_min_price_excl_tax;
        pricingSchemeModel.sales_max_price_excl_tax = data.sales_max_price_excl_tax;
        pricingSchemeModel.purchase_min_price_excl_tax = data.purchase_min_price_excl_tax;
        pricingSchemeModel.purchase_max_price_excl_tax = data.purchase_max_price_excl_tax;
        pricingSchemeModel.guid_pricing_scheme_link = data.guid
        pricingSchemeModel.purchase_selling_list_price_incl_tax = data.purchase_selling_list_price_incl_tax;
        
        //console.log("Pricing Scheme Model",pricingSchemeModel);
        purchaseSidePricingSchemeList.push(pricingSchemeModel);
     })

     //console.log("Pricing Scheme List",purchaseSidePricingSchemeList);

     this.filteredPricingSchemes = purchaseSidePricingSchemeList.filter(pricingScheme => 
      pricingScheme.pricingSchemeAccessKey === this.pricingSchemeAccessKey
    );

    //console.log("Filered Pricing Scheme",this.filteredPricingSchemes);
    //console.log("defaultPricingSchemeHdr", this.defaultPricingSchemeHdr.value)
    const defaultPricingSchemeModel = this.filteredPricingSchemes.find(l => l.guid_pricing_scheme_hdr === this.defaultPricingSchemeHdr.value);

    if(defaultPricingSchemeModel){
      this.onPriceSelected(defaultPricingSchemeModel)
      this.pricingScheme.patchValue(defaultPricingSchemeModel);
    } else if (this.filteredPricingSchemes.length == 1) {
      //console.log("filtered pricing scheme length",this.filteredPricingSchemes.length);
      this.onPriceSelected(this.filteredPricingSchemes[0])
    }
    })
  }

  onPriceSelected(e){
    //console.log("Price Selected Event",e);
    this.selectedPricingScheme.emit(e);
  }
  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
